import { type MobileEntityType, notifyMobileEntityChanged } from "@btnet/utilities-webview";

export type EntityType = MobileEntityType;

export function notifyEntityChanged(
    entityType: EntityType,
    action: "add" | "update" | "delete",
    entityIds?: (string | number)[],
): void {
    notifyMobileEntityChanged(entityType, action, entityIds);
}
